const enum FileSource {
  Capture = 'Capture',
  PendingTray = 'PendingTray',
}

export default FileSource;
